<template>
  <!-- content -->
  <div class="board_list_wrap">
    <div class="board_list">
      <div class="top">
        <div class="num">번호</div>
        <div class="title">제목</div>
        <div class="writer">글쓴이</div>
        <div class="date">작성일</div>
        <div class="count">조회</div>
      </div>
      <div v-on:click="onView(boardList)" class="list" v-for="(boardList, idx) in boardLists" :key="idx">
        <div class="num">{{ item.no - idx }}</div>
        <div class="title">{{ boardList.title }}</div>
        <div class="writer">{{ boardList.writer }}</div>
        <div class="date">{{ boardList.date.substring(0, 10) }}</div>
        <div class="count">{{ boardList.count }}</div>
      </div>
    </div>

    <Paging :toPage="item" @pageClick="pageClickEvent"></Paging>
    <div class="board_btn">
      <router-link :to="{ name: 'write' }" class="btn_write">등록</router-link>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Paging from '../../static/Paging.vue'
export default {
  components: {
    Paging,
  },
  data() {
    return {
      boardLists: [], //받은 데이터
      date: '',
      count: '',
      item: {
        pageSize: 10, //페이지 내 데이터 개수(안해도 10개)
        pageNow: 1, //현재 페이지 번호
        totalCount: '',
        pageNum: '',
        no: '',
      },
    }
  },
  methods: {
    onDate: function () {
      this.date = moment().format('YYYY-MM-DD HH:mm:ss')
    },
    pageClickEvent: function (e) {
      this.item.pageNow = e
      this.getData()
    },
    getData() {
      axios
        .get('/api/consult/paging', {
          params: { pagesize: this.item.pageSize, pagenow: this.item.pageNow },
        })
        .then((res) => {
          this.item.totalCount = res.data.totalCount
          this.boardLists = res.data.data
          this.item.pageNum = parseInt(this.item.totalCount / this.item.pageSize) + 1
          this.item.no = this.item.totalCount - this.item.pageSize * (this.item.pageNow - 1)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    updateOne(e) {
      e.count++
      axios({
        url: '/api/consult/updateOne',
        method: 'POST',
        data: {
          id: e.id,
          count: e.count,
        },
      })
        .then((res) => {
          if (res.data.success == true) {
          }
        })
        .catch((err) => {
          alert(err)
        })
    },

    onView: function (event) {
      var id = event.id
      if (
        event.checking == undefined ||
        event.checking == 'undefined' ||
        event.checking == null ||
        event.checking == 'N' ||
        event.checking == '' ||
        event.password == undefined ||
        event.password == 'undefined' ||
        event.password == null ||
        event.password == ''
      ) {
        this.$router.push({ name: 'view', query: { id: id, pageNow: this.item.pageNow } })
        this.updateOne(event)
        history.replaceState({}, null, location.pathname)
      } else {
        this.$router.push({ name: 'secure', query: { id: id, pageNow: this.item.pageNow, key: 'list' } })
        history.replaceState({}, null, location.pathname)
      }
    },
  },
  created() {
    this.getData()
  },
}
</script>

<style>
.cont1 {
  color: black;
  text-decoration: none;
}
.list.title {
  text-overflow: ellipsis;
}
.list {
  cursor: pointer;
}
</style>
